import { Box } from '@mui/material';
import React from 'react';

import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';

import { useSxStyles } from './useStyles';

type PropsType = {
  level: number;
  items: number[];
};

export const CompLevel = (props: PropsType) => {
  const sxStyles = useSxStyles();
  const { items, level } = props;

  return (
    <>
      {items.map((item: number, index: number) => (
        <Box component="span" key={index} sx={sxStyles.cssScale}>
          <LegacyFAIcon
            sx={level === item ? sxStyles.iconColor : sxStyles.circle}
            FAIcon={LegacyFAIcons.Circle}
          />
        </Box>
      ))}
    </>
  );
};
